import React from "react";
import { useI18n, LANGUAGES } from "../i18n/I18nContext";

export function MockBadge() {
  return null;
}

export function LanguageToggle({ className = "" }) {
  const { lang, setLang } = useI18n();
  return (
    <div className={`inline-flex border border-border font-mono text-[10px] uppercase tracking-widest2 ${className}`}>
      {LANGUAGES.map((l) => (
        <button
          key={l}
          onClick={() => setLang(l)}
          data-testid={`lang-toggle-${l}`}
          aria-pressed={lang === l}
          className={`px-2 py-1 transition-colors ${lang === l ? "bg-signal-green text-black" : "text-text-muted hover:text-white"}`}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}

export function ZoneChip({ zone, size = "sm" }) {
  const map = {
    GREEN: { cls: "chip-green", label: "GREEN" },
    GREEN_BORDER: { cls: "chip-green", label: "GREEN·BORDER" },
    YELLOW: { cls: "chip-yellow", label: "YELLOW" },
    RED: { cls: "chip-red", label: "RED" },
  };
  const e = map[zone] || map.RED;
  const sz = size === "lg" ? "text-xs px-2.5 py-1" : "text-[10px] px-2 py-0.5";
  return (
    <span className={`${e.cls} ${sz} font-mono font-bold tracking-widest2 inline-flex items-center`}>
      {e.label}
    </span>
  );
}

export function LageBadge({ grade }) {
  const colors = {
    A: "bg-white text-black",
    "B+": "bg-zinc-300 text-black",
    B: "bg-zinc-500 text-black",
    "B-": "bg-zinc-700 text-zinc-200",
  };
  return (
    <span
      className={`inline-flex items-center justify-center px-1.5 py-0.5 text-[10px] font-mono font-bold w-9 ${colors[grade] || "bg-zinc-600 text-white"}`}
    >
      {grade}
    </span>
  );
}

export function Stat({ label, value, sub, accent = "white", testId }) {
  const accentMap = {
    white: "text-white",
    green: "text-signal-green",
    yellow: "text-signal-yellow",
    red: "text-signal-red",
  };
  return (
    <div className="p-5 border border-border bg-surface" data-testid={testId}>
      <div className="overline">{label}</div>
      <div className={`mt-2 num text-3xl md:text-4xl font-light ${accentMap[accent]}`}>{value}</div>
      {sub && <div className="mt-1 text-xs text-text-muted num">{sub}</div>}
    </div>
  );
}

export function Spinner({ size = 16 }) {
  return (
    <span
      className="inline-block border border-white/20 border-t-white animate-spin"
      style={{ width: size, height: size, borderRadius: "50%" }}
    />
  );
}

export function Button({ children, variant = "primary", className = "", ...props }) {
  const base =
    "inline-flex items-center justify-center gap-2 px-4 py-2 font-mono text-xs uppercase tracking-widest2 transition-colors disabled:opacity-40 disabled:cursor-not-allowed";
  const variants = {
    primary: "bg-white text-black hover:bg-signal-green",
    ghost: "border border-zinc-700 text-white hover:border-white hover:bg-surfaceHover",
    danger: "border border-signal-red/40 text-signal-red hover:bg-signal-red/10",
    green: "bg-signal-green text-black hover:bg-white",
  };
  return (
    <button className={`${base} ${variants[variant]} ${className}`} {...props}>
      {children}
    </button>
  );
}

export function Input({ className = "", ...props }) {
  return (
    <input
      className={`w-full bg-bg border border-border px-3 py-2 text-sm font-mono text-white focus:border-white outline-none ${className}`}
      {...props}
    />
  );
}
